import React, { useMemo } from "react";
import moment from "moment";
import { isAbsent } from "./StaffAnalyticsTab";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]; // isoWeekday 1–7
const ROLES = [
  { key: "trainer", label: "Trainers" },
  { key: "receptionist", label: "Sales Execs" },
];

const getCellClass = (rate) => {
  if (rate === null) return "sta-heatmap__cell--0";
  if (rate < 15) return "sta-heatmap__cell--low";
  if (rate < 30) return "sta-heatmap__cell--mid";
  return "sta-heatmap__cell--high";
};

const AnalyticsDayHeatmap = ({ allShifts = [] }) => {
  const grid = useMemo(() => {
    const init = () => DAYS.map(() => ({ absent: 0, total: 0 }));
    const map = { trainer: init(), receptionist: init() };

    allShifts.forEach(({ accountType, att, date }) => {
      if (!date) return;
      const role = accountType === "trainer" ? "trainer" : "receptionist";
      const dow = moment(date, "YYYY-MM-DD").isoWeekday() - 1; // 0=Mon
      if (dow < 0 || dow > 6) return;
      if (att?.status_value === "on_leave" || att?.status_value === "day_off") return;
      map[role][dow].total++;
      if (isAbsent(att)) map[role][dow].absent++;
    });

    return map;
  }, [allShifts]);

  return (
    <div className="sta-heatmap">
      <div className="sta-heatmap__grid">
        <div />
        {DAYS.map((d) => (
          <div key={d} className="sta-heatmap__header">{d}</div>
        ))}
        {ROLES.map(({ key, label }) => (
          <React.Fragment key={key}>
            <div className="sta-heatmap__row-label">{label}</div>
            {DAYS.map((_, i) => {
              const cell = grid[key][i];
              const rate = cell.total > 0 ? Math.round((cell.absent / cell.total) * 100) : null;
              return (
                <div
                  key={i}
                  className={`sta-heatmap__cell ${getCellClass(rate)}`}
                  title={
                    cell.total > 0
                      ? `${cell.absent} absent / ${cell.total} expected (${rate}% absent rate)`
                      : "No data"
                  }
                >
                  {rate !== null ? `${rate}%` : "—"}
                </div>
              );
            })}
          </React.Fragment>
        ))}
      </div>
      <div className="sta-heatmap__legend">
        <div className="sta-legend-swatch" style={{ background: "#d4edda" }} />
        <span>&lt;15% absent</span>
        <div className="sta-legend-swatch" style={{ background: "#fff3cd", marginLeft: 8 }} />
        <span>15–30%</span>
        <div className="sta-legend-swatch" style={{ background: "#f8d7da", marginLeft: 8 }} />
        <span>&gt;30%</span>
        <div className="sta-legend-swatch" style={{ background: "#e9ecef", marginLeft: 8 }} />
        <span>No data</span>
      </div>
    </div>
  );
};

export default AnalyticsDayHeatmap;
